import Notice from 'gu-ui-kit/Notice'
import Typography from 'gu-ui-kit/Typography'
import React, { useCallback } from 'react'
import { Trans } from 'react-i18next'
import { matchPath, useLocation } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import { useSidePanel } from 'modules/SidePanel'
import { TICKETS_PANEL_ID } from 'modules/Tickets/constants'
import { IS_APP_PRODUCT_GETUNIQ } from 'utils/constants/product'
import styles from 'components/IncidentBanner/incident-banner.module.scss'

const isFinanceBalanceRoute = (pathname) =>
  Boolean(matchPath(pathname, { path: ROUTES.FINANCE_WALLETS }))

export const IncidentBanner = () => {
  const { pathname } = useLocation()
  const { toggle } = useSidePanel()

  const openTicketsPanel = useCallback(() => {
    toggle(TICKETS_PANEL_ID)
  }, [toggle])

  if (!IS_APP_PRODUCT_GETUNIQ || isFinanceBalanceRoute(pathname)) {
    return null
  }

  return (
    <Notice
      alignItems={'start'}
      className={styles['banner']}
      iconColor={'Label-Onsurface'}
      role={'status'}
      severity={'info'}
    >
      <Trans
        components={[
          <Typography
            key={'tickets'}
            className={styles['banner__link']}
            color={'Label-Onsurface'}
            component={'a'}
            variant={'Body-20'}
            onClick={openTicketsPanel}
          >
            остаются на связи
          </Typography>,
        ]}
        i18nKey={'common::incident_banner.message'}
      />
    </Notice>
  )
}

export default IncidentBanner
